var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"variable"},[_c('transition',{attrs:{"name":"move-fade-right-to-left"}},[_c('router-view',{staticClass:"app-router-view"})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }